import 'css-chunksrc/client/common/helpTooltip/styles.scss';export default {
  "help": "_help_1u4ie_1",
  "helpIcon": "_helpIcon_1u4ie_6",
  "helpTooltip": "_helpTooltip_1u4ie_21",
  "helpTitle": "_helpTitle_1u4ie_38",
  "helpBody": "_helpBody_1u4ie_43",
  "helpLink": "_helpLink_1u4ie_47",
  "helpBold": "_helpBold_1u4ie_52",
  "helpGreen": "_helpGreen_1u4ie_56",
  "helpOrange": "_helpOrange_1u4ie_61",
  "helpRed": "_helpRed_1u4ie_66"
};